module.exports = __webpack_public_path__ + "static/img/coffee.fc03c8ec.svg";